import {
  REQUIREMENT_DONUT_SIZE,
  REQUIREMENT_DONUT_STROKE,
} from "../constants";
import type { DonutSlice } from "./utilities";

export function ObligationDonutSvg({
  slices,
  total,
}: {
  slices: DonutSlice[];
  total: number;
}) {
  const radius = (REQUIREMENT_DONUT_SIZE - REQUIREMENT_DONUT_STROKE) / 2;
  const circumference = 2 * Math.PI * radius;
  let offsetAccumulator = 0;

  return (
    <svg
      width={REQUIREMENT_DONUT_SIZE}
      height={REQUIREMENT_DONUT_SIZE}
      viewBox={`0 0 ${REQUIREMENT_DONUT_SIZE} ${REQUIREMENT_DONUT_SIZE}`}
    >
      <circle
        cx={REQUIREMENT_DONUT_SIZE / 2}
        cy={REQUIREMENT_DONUT_SIZE / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={REQUIREMENT_DONUT_STROKE}
        className="text-muted"
      />
      {total > 0 &&
        slices.map((slice) => {
          const fraction = slice.count / total;
          const dash = circumference * fraction;
          const gap = circumference - dash;
          const strokeDashoffset = -offsetAccumulator;
          offsetAccumulator += dash;

          return (
            <circle
              key={slice.key}
              cx={REQUIREMENT_DONUT_SIZE / 2}
              cy={REQUIREMENT_DONUT_SIZE / 2}
              r={radius}
              fill="none"
              stroke={slice.meta.stroke}
              strokeWidth={REQUIREMENT_DONUT_STROKE}
              strokeDasharray={`${dash} ${gap}`}
              strokeDashoffset={strokeDashoffset}
              transform={`rotate(-90 ${REQUIREMENT_DONUT_SIZE / 2} ${REQUIREMENT_DONUT_SIZE / 2})`}
            />
          );
        })}
    </svg>
  );
}
